const showFields = ($button) => {
  let $input = document.querySelector('[name="formType"]')
  if($button === null) return

  if(!$button.classList.contains('active')) {
    document.querySelectorAll('.btn--tabs').forEach($button => $button.classList.remove('active'))
    $button.classList.add('active')
    $input.value = ($button.getAttribute('href') == '#sale') ? 'Venta' : 'Renta';
    // --
    let target = $button.getAttribute('href'),
        $fields = document.querySelectorAll('[data-target]')

    if($fields.length > 0) {
      $fields.forEach($field => $field.classList.toggle('x:hide', $field.getAttribute('data-target') !== target))
    }
  }
}

const formTabs = () => {
  let $buttons = document.querySelectorAll('.btn--tabs')
  showFields(document.querySelector('.btn--tabs.active') || null)
  $buttons.forEach(($button) => {
    $button.addEventListener('click', (event) => {
      event.preventDefault()
      showFields($button)
    })
  })
}
export default formTabs
